import React from 'react';

import { styled } from '@mui/material';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import AnimatedSkeletonMultiline from '~/components/AnimatedSkeletonMultiline';
import {
  SKELETON_TEXT_HEIGHT_PX,
  SKELETON_TEXT_HEIGHT_SMALL_PX,
  SMALL_MARGIN_PX,
  TINY_MARGIN_PX,
} from '~/theme';

const GlossaryLoadingCard = () => {
  return (
    <li>
      <Wrapper>
        <CategoriesWrapper>
          <LoadingCategory />
          <LoadingCategory />
        </CategoriesWrapper>
        <LoadingTitle xs={SKELETON_TEXT_HEIGHT_PX} />
        <LoadingDescription xs={SKELETON_TEXT_HEIGHT_SMALL_PX} lines={4} spacer={TINY_MARGIN_PX} />
        <LoadingBtn xs={SKELETON_TEXT_HEIGHT_SMALL_PX} />
      </Wrapper>
    </li>
  );
};

export default GlossaryLoadingCard;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;
const CategoriesWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  & > *:first-child {
    width: 130px;
  }
  & > *:nth-child(2) {
    width: 170px;
  }
`;
const LoadingCategory = styled(AnimatedSkeleton)`
  margin-right: 10px;
  margin-bottom: ${SMALL_MARGIN_PX};
  height: 29px;
`;
const LoadingTitle = styled(AnimatedSkeleton)`
  margin-bottom: ${SMALL_MARGIN_PX};
  max-width: 100%;
  width: 400px;
`;
const LoadingDescription = styled(AnimatedSkeletonMultiline)`
  margin-bottom: ${SMALL_MARGIN_PX};
`;
const LoadingBtn = styled(AnimatedSkeleton)`
  width: 120px;
`;
